document.addEventListener('DOMContentLoaded', () => {

    const popup = document.getElementById('GenderPopup');

    if (!popup) return;

    const body = document.body;
    const overlay = popup.querySelector('.gender-popup__overlay');
    const closeButtons = popup.querySelectorAll('[data-close-gender-popup]');
    const focusableSelector =
        'a[href], button:not([disabled]), input:not([disabled]), textarea, select';

    function lockScroll() {
        body.style.overflow = 'hidden';
    }

    function unlockScroll() {
        body.style.overflow = '';
    }

    function openPopup() {

        popup.classList.add('is-visible');

        lockScroll();

        const firstFocusable = popup.querySelector(focusableSelector);

        if (firstFocusable) {
            setTimeout(() => {
                firstFocusable.focus();
            }, 150);
        }
    }

    function closePopup() {

        popup.classList.remove('is-visible');

        unlockScroll();

    }

    // -----------------------------
    // Open Popup
    // -----------------------------

    document.querySelectorAll('[data-open-gender-popup]').forEach(trigger => {

        trigger.addEventListener('click', function (e) {

            e.preventDefault();

            openPopup();

        });

    });

    // -----------------------------
    // Close Buttons
    // -----------------------------

    closeButtons.forEach(button => {

        button.addEventListener('click', function (e) {

            e.preventDefault();

            closePopup();

        });

    });

    // -----------------------------
    // Overlay Click
    // -----------------------------

    if (overlay) {

        overlay.addEventListener('click', function () {

            closePopup();

        });

    }

    // -----------------------------
    // ESC Key
    // -----------------------------

    document.addEventListener('keydown', function (e) {

        if (
            e.key === 'Escape' &&
            popup.classList.contains('is-visible')
        ) {

            closePopup();

        }

    });

    // -----------------------------
    // Prevent Closing when clicking
    // inside popup
    // -----------------------------

    popup
        .querySelector('.gender-popup__content')
        .addEventListener('click', function (e) {

            e.stopPropagation();

        });

});